export * from './gutachten-sorter.component';
export * from './gutachten-sorter.component.module';